import { useTranslation } from "react-i18next";
import "./Clinical.scss";
import image from "../../assets/MatchaWhite.png";

export default function Clinical() {
	const { t } = useTranslation();
	const points = t("clinical.points", { returnObjects: true });

	return (
		<section id="clinical" className="section dark clinical">
			<div className="clinical__inner">
				{/* TEXT */}
				<div className="clinical__content">
					<h2>{t("clinical.title")}</h2>

					<p className="clinical__intro">{t("clinical.intro")}</p>

					<ul className="clinical__list">
						{points.map((item, index) => (
							<li key={index}>{item}</li>
						))}
					</ul>

					<p className="clinical__note">{t("clinical.note")}</p>
				</div>

				{/* IMAGE */}
				<div className="clinical__media">
					<div className="clinical__imageCard">
						<img src={image} alt="Revibrain product" />
					</div>
				</div>
			</div>
		</section>
	);
}
